import React, { useCallback } from 'react';
import TextField from './TextFieldEngine';

export const emailFieldValidator = (t, required) => value => {
  const isValidEmailAddress = v => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const results = v && v.length ? re.test(String(v).toLowerCase()) : true;
    return results;
  };
  if (required && !value) {
    return 'Please enter a valid email address.';
  }
  if (
    (value && !isValidEmailAddress(value)) ||
    (value && value.indexOf(' ') !== -1)
  ) {
    return 'Please enter a valid email address.';
  }
};

const EmailFieldEngine = ({
  internalId,
  value,
  setValue,
  required,
  readOnly,
  ...fieldProps // for future development, know whe have this
}) => {
  const extendedValidator = useCallback((value, error) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const results =
      value && value.length ? re.test(String(value).toLowerCase()) : true;

    if (!results) {
      error = 'Please enter a valid email address.';
    }
    return error;
  }, []);

  const viewProps = {
    internalId,
    value,
    setValue,
    required,
    readOnly,
    extendedValidator
  };

  return <TextField {...viewProps} />;
};

export default EmailFieldEngine;
